/* src/app/shared/audit-reason-dialog/audit-reason-dialog.component.css */
.full-width {
  width: 100%;
}
.subtitle {
  margin: 0 0 8px;
  font-size: 15px;
}
.hint {
  margin: 0 0 16px;
  color: #6b7280;
  font-size: 13px;
}
h2.danger {
  color: #b3261e;
}
/*# sourceMappingURL=audit-reason-dialog.component.css.map */
